import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index'
//帮助文档
import problem from '@/page/problem'
import UserManage from '@/page/userManagement/userManagement'
import detail from '@/page/detail'
import userPower from '@/page/userManagement/userPower'
import accountList from '@/page/accountList/accountList'
import accountListTag from '@/page/accountList/accountListTag'
// 素材中心
import materialCenter from '@/page/materialCenter/materialCenter'
import rectifyArticle from '@/page/materialCenter/rectifyArticle'
import myCollect from '@/page/materialCenter/myCollect'
import myMaterial from '@/page/materialCenter/myMaterial'
import matrixArticle from '@/page/materialCenter/matrixArticle'
import matrixArticleFinish from '@/page/materialCenter/matrixArticleFinish'
// 任务指令
import taskOrders from '@/page/taskOrders/taskOrders'
import issueOrders from '@/page/taskOrders/issueOrders'
import createTasks from '@/page/taskOrders/createTasks'
import taskMyArticle from '@/page/taskOrders/taskMyArticle'
import articleReview from '@/page/taskOrders/articleReview'
//数据分析
import dataAnalysis from '@/page/dataAnalysis/dataAnalysis'
import wbdataAnalysis from '@/page/dataAnalysis/wbdataAnalysis'
import ttdataAnalysis from '@/page/dataAnalysis/ttdataAnalysis'
import myFans from '@/page/dataAnalysis/myFans'
import myArticle from '@/page/dataAnalysis/myArticle'
import wbmyArticle from '@/page/dataAnalysis/wbmyArticle'
import ttmyArticle from '@/page/dataAnalysis/ttmyArticle'
//媒体榜单
import mediaList from '@/page/mediaList/mediaList'
import mediaListArticle from '@/page/mediaList/mediaListArticle'
import hotText from '@/page/mediaList/hotText'

import PersonalCenter from '@/page/personalCenter/personalCenter'
import memberPurchase from '@/page/personalCenter/memberPurchase'
import myDownload from '@/page/myDownload'
import permissionComparison from '@/page/personalCenter/permissionComparison'
import OnlineEdit from '@/page/onlineEdit'


Vue.use(Router)

export default new Router({
    // pageType判断页面属于哪个导航分类
    // keepAlive 不同页面的头部颜色 首页1 
    // leftShow 是否有左侧导航
    // levelPower 权限等级 控制权限页面的显示1是不做权限处理 2是需要做权限处理
    // power机构等级权限
    mode: 'history',  //去掉url中的#
    routes: [
        {
            path: '/',
            name: '首页',
            component: index,
            meta:{
                requireAuth: false,//登录状态
                leftShow:false,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/problem',
            name: '帮助文档',
            component: problem,
            meta:{
                requireAuth: false,//登录状态
                leftShow:false,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/accountList',
            name: '账号列表',
            component: accountList,
            meta:{
                requireAuth:true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/detail',
            name: '详情页',
            component: detail,
            meta:{
                requireAuth:true,//登录状态
                leftShow:false,
                topMenu:false,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/userManagement',
            name: '用户管理',
            component: UserManage,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1,//操作权限
                vip:true
            }
        },
        {
            path: '/userManagement/userPower',
            name: '用户权限',
            component: userPower,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1,//操作权限
                vip:true
            }
        },
        {
            path: '/accountList/accountListTag',
            name: '账号列表-新建标签',
            component: accountListTag,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter',
            name: '素材中心',
            component: materialCenter,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter/myCollect',
            name: '我的收藏',
            component: myCollect,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter/myMaterial',
            name: '我的素材',
            component: myMaterial,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter/rectifyArticle',
            name: '矩阵文章',
            component: rectifyArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter/matrixArticle',
            name: '发布文章',
            component: matrixArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/materialCenter/matrixArticleFinish',
            name: '矩阵文章发布完成',
            component: matrixArticleFinish,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/taskOrders',
            name: '任务指令',
            component: taskOrders,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1,//操作权限
                pageActive:3,
            }
        },
        {
            path: '/taskOrders/issueOrders',
            name: '发布指令',
            component: issueOrders,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:2,//操作权限
                pageActive:2,
            }
        },
        {
            path: '/taskOrders/createTasks',
            name: '创建任务',
            component: createTasks,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:2//操作权限
            }
        },
        {
            path: '/taskOrders/taskMyArticle',
            name: '我的文章',
            component:taskMyArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1,//操作权限
            }
        },
        {
            path: '/taskOrders/articleReview',
            name: '文章审核',
            component:articleReview,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:2,//等级权限
                power:1,//操作权限
            }
        },
        {
            path: '/wxdataAnalysis',
            name: '数据分析',
            component:dataAnalysis,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/wbdataAnalysis',
            name: '数据分析',
            component:wbdataAnalysis,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/ttdataAnalysis',
            name: '数据分析',
            component:ttdataAnalysis,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/wxdataAnalysis/myFans',
            name: '我的粉丝',
            component:myFans,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/wxdataAnalysis/myArticle',
            name: '我的文章',
            component:myArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/wbdataAnalysis/wbmyArticle',
            name: '我的文章-微博',
            component:wbmyArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/ttdataAnalysis/ttmyArticle',
            name: '我的文章-头条',
            component:ttmyArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1,//操作权限
                pageActive:1,
            }
        },
        {
            path: '/mediaList',
            name: '媒体榜单',
            component:mediaList,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/mediaList/mediaListArticle',
            name: '媒体榜单-文章',
            component:mediaListArticle,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/mediaList/hotText',
            name: '媒体榜单-文章',
            component:hotText,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/personalCenter',
            name: '我的会员',
            component:PersonalCenter,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:2,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/personalCenter/memberPurchase',
            name: '会员购买',
            component:memberPurchase,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:2,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/personalCenter/permissionComparison',
            name: '权限对比',
            component:permissionComparison,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:2,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/myDownload',
            name: '我的下载',
            component:myDownload,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:2,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        },
        {
            path: '/onlineEdit',
            name: '编辑器',
            component:OnlineEdit,
            meta:{
                requireAuth: true,//登录状态
                leftShow:true,
                topMenu:true,
                keepAlive:1,
                levelPower:1,//等级权限
                power:1//操作权限
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js